module.exports = __webpack_public_path__ + "img/seat-2.6d0e9bbd.jpg";